<template>
  <div class="pay">
    <BaseHeaderBar
      title="Kode pembayaran"
      :showCustomerService="false"
      :showBackButton="true"
    />
    <div class="pay-amount">
      <p class="amount">Rp{{ formatNumberWithCommas(payInfo.padryAmount) }}</p>
      <p class="label">Jumlah pembayaran</p>
    </div>
    <div class="pay-info-list">
      <div class="info">
        <p class="label">Nama Bank</p>
        <p class="value">{{ payInfo.padryChannel }}</p>
      </div>
      <div class="info">
        <p class="label">Metode pembayaran</p>
        <p class="value">{{ payInfo.padryWay }}</p>
      </div>
      <div class="info">
        <p class="label">Masa berlaku</p>
        <p class="value">{{ payInfo.lodrseTime }}</p>
      </div>
      <div
        class="info"
        v-clipboard:copy="payInfo.padrymentCode"
        v-clipboard:success="onCopySuccess"
        v-clipboard:error="onCopyError"
      >
        <p class="label">
          Kode pembayaran
          <img class="copy-btn" src="@/assets/img/copy-btn.jpg" />
        </p>
        <p class="value">{{ payInfo.padrymentCode }}</p>
      </div>
    </div>
    <div class="extra-info">
      <div class="tabs">
        <div
          :class="activate == 1 ? 'tab activate_tab' : 'tab'"
          @click="activate = 1"
        >
          Hal yang perlu diperhatikan
        </div>
        <div
          :class="activate == 2 ? 'tab activate_tab' : 'tab'"
          @click="activate = 2"
        >
          Cara Pembayaran
        </div>
      </div>
      <div class="tab-content" v-show="activate == 1">
        <p v-for="(item, index) in payInfo.prdrecautions.step" :key="index">
          {{ item }}
        </p>
      </div>
      <div class="tab-content" v-show="activate == 2">
        <p
          v-for="(item, index) in payInfo.redrpaymentProcess[0].step"
          :key="index"
        >
          {{ item }}
        </p>
      </div>
    </div>
    <button type="button" class="paid-btn" @click="onPaid">
      Saya sudah melakukan pembayaran
    </button>
    <van-dialog
      v-model="visible"
      :showConfirmButton="false"
      close-on-click-overlay
      class="repayment-success-dialog"
    >
      <p class="tip">Pembayaran berhasil！</p>
      <img src="@/assets/img/huankuanchenggong.png" alt="" />
      <button
        v-if="payInfo.padryCodeid"
        type="button"
        class="ok-btn"
        @click="onConfirm"
      >
        ok
      </button>
      <button type="button" class="ok-btn" @click="onConfirm">ok</button>
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tab, Tabs, Dialog, Toast } from 'vant'
import dialogVisible from '@/mixins/dialogVisible'
import request from '@/utils/request'
import VueClipboard from 'vue-clipboard2'

Vue.use(Tab)
Vue.use(Tabs)
Vue.use(VueClipboard)

export default {
  name: 'Pay',
  mixins: [dialogVisible],
  components: {
    [Dialog.Component.name]: Dialog.Component
  },
  data () {
    return {
      payInfo: {
        prdrecautions: {},
        redrpaymentProcess: [{}]
      },
      activate: 1
    }
  },
  created () {
    this.getPayCode()
  },
  methods: {
    getPayCode () {
      const { repayType, amount, orderId, channelId, payChannel, name, payWay, payWayName } = this.$route.query
      const postData = {
        ordrderID: orderId,
        padryAmount: amount,
        padryType: repayType,
        padrymentChannel: channelId,
        padryChannel: payChannel,
        padryChannelName: name,
        padryWay: payWay,
        padryWayName: payWayName
      }
      request.post('crdreatePaymentCode', postData)
        .then(res => {
          this.payInfo = res
        })
    },
    onCopySuccess () {
      Toast('Berhasil disalin')
    },
    onCopyError () {
      Toast('Penyalinan gagal')
    },
    onPaid () {
      const { orderId } = this.$route.query
      const postData = {
        ordrderID: orderId,
        padryCodeid: this.payInfo.padryCodeid
      }
      request.post('redrpaymentStatus', postData)
        .then(res => {
          if (res.padryStatus === 2) {
            this.visible = true
          } else {
            Toast(res.padryMsg)
          }
        })
    },
    onConfirm () {
      this.onCloseDialog()
      this.$router.push('/home')
    }
  }
}
</script>

<style scoped lang="less">
.pay {
  min-height: 100vh;
  background: url("../assets/img/page_bg_zhifu.png") no-repeat;
  background-size: 100%;
  padding-bottom: 80px;
}

.pay-amount {
  padding-top: 40px;
  padding-bottom: 50px;
  padding-left: 62px;
  margin: 30px;
  margin-top: 350px;
  background: url("../assets/img/huankuan_bg.png") no-repeat;
  background-size: 100% 100%;
  .amount {
    font-size: 30px;
    color: #fff;
    margin-bottom: 30px;
    font-weight: normal;
    font-size: 48px;
  }
  .label {
    font-size: 28px;
    font-weight: 500;
    color: #fcecd1;
  }
}

.pay-info-list {
  padding: 0 30px;
  margin-left: 30px;
  margin-right: 30px;
  background: url("../assets/img/hunakuanInfo_bg.png");
  background-size: 100% 100%;
  height: 323px;
  .info {
    height: 77px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 2px solid rgba(225, 225, 225, 0.1);
    font-size: 30px;
    color: #ffffff;
    .label {
      font-weight: 500;
    }
    .value {
      font-weight: bold;
    }
  }
  .info:last-child {
    border: none;
  }

  .label {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
  }

  .copy-btn {
    width: 30px;
    height: 30px;
    margin-left: 20px;
    display: flex;
    position: absolute;
    right: 20px;
  }

  p {
    font-weight: 600;
  }

  & > .label,
  & > .value {
    font-size: 26px;
    color: #001c44;
  }
}

.extra-info {
  position: relative;
  margin: 36px;
  background: #fff;
  border-radius: 30px;
  padding: 20px 30px;
  margin-bottom: 50px;
  background: url("../assets/img/hunakuanInfo_bg.png");
  background-size: 100% 100%;
  height: 446px;

  .tabs {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    .tab {
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      font-weight: bold;
      font-size: 32px;
      color: #4bc4b3;
      background: #fff;
      height: 84px;
      border-radius: 42px;
    }
    .activate_tab {
      color: #fff;
      background: #4bc4b3;
    }
  }
}

.tab-content {
  margin-top: 30px;
  margin-bottom: 30px;
  overflow-y: scroll;
  overflow: auto;
  height: 350px;

  p {
    font-size: 29px;
    font-weight: 400;
    color: #fff;
    line-height: 46px;
    word-wrap: break-word;

    &:nth-child(n + 2) {
      margin-top: 16px;
    }
  }
}

.paid-btn {
  .submit-btn;
  width: 650px;
  margin-top: 20px;
  font-size: 34px;
}

.repayment-success-dialog {
  width: 594px;
  height: 620px;

  img {
    width: 307px;
    height: 312px;
    margin: 0 auto;
    margin-top: 40px;
  }
}

.tip {
  line-height: 42px;
  font-size: 38px;
  color: #fff;
  font-weight: bold;
  text-align: center;
  margin-top: 30px;
}

.ok-btn {
  .submit-btn;
  width: 520px;
  margin-top: 50px;
  margin-bottom: 50px;
}
</style>
